import { render, staticRenderFns } from "./ServiceDetailPriceCard.vue?vue&type=template&id=41a73c0a&scoped=true&"
import script from "./ServiceDetailPriceCard.vue?vue&type=script&lang=ts&"
export * from "./ServiceDetailPriceCard.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceDetailPriceCard.vue?vue&type=style&index=0&id=41a73c0a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a73c0a",
  null
  
)

export default component.exports